// extracted by mini-css-extract-plugin
export default {"navigationBarHeight":"72px","errorBoundaryContainer":"ErrorBoundary_errorBoundaryContainer__4bpaV","errorBoundaryBody":"ErrorBoundary_errorBoundaryBody__3Oj+X"};